/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import { Dropdown } from "../reuseable";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle,
} from "chart.js";
import { Chart } from "react-chartjs-2";

/*REDUX*/
import {
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
} from "../../App/actions/propertiesActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*PICTURE*/
import chart_image_1 from "../../Assets/svg/chart_image_1.svg";
import chart_image_2 from "../../Assets/svg/chart_image_2.svg";

/*FUNCTION*/
import generate_array_color from "../../App/validation/generate_array_color";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle
);

function MANAGE_CHART({
  auth,
  layer,
  project,
  properties,
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
  getDetailLayerById,
}) {
  const [state, set_state] = useState({
    mode_input_chart: "add", //add || edit
    modal_input_chart: false,
    modal_delete_chart: false,
    modal_example_not_use_y: false,
    modal_example_use_y: false,

    chart_id_delete: "",
    chart_name_delete: "",

    ina: "",
    eng: "",
    x_axis_field_key: "",
    is_use_y_axis: false,
    y_axis_field_key: "",
    chart_type: "pie", //line, bar, pie
    is_use_custom_order: true,
    x_element_custom_order: [],
    color_default: "#373784",
    color_hover: "#f38026",
    is_npv_kai: false,
    wacc_field_key: "",
  });

  const on_get_layer = () => {
    const { layer_id, geo_layer_list } = layer;
    const { geo_project } = project;
    const layer_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id
    );

    if (!layer_item) {
      return;
    }
    const geo_layer_item = layer_item.geo_layer;
    const body = {
      geo_layer_id: geo_layer_item._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      folder_id: layer_item?.folder,
      capex_value: properties.capex_value,
      geo_layer_item,
    };
    getDetailLayerById(body);
  };

  // Call on_get_layer on component mount if features_length is 0
  useEffect(() => {
    const { layer_id, geo_layer_list } = layer;
    const layer_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id
    );

    const features_length =
      layer_item?.geo_layer?.geojson?.features?.length || 0;

    if (features_length === 0) {
      on_get_layer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle_edit_chart = (chart_object) => {
    set_state((prev) => ({
      ...prev,
      modal_input_chart: !prev.modal_input_chart,
      mode_input_chart: "edit",
      ...(chart_object || {}),
    }));
  };

  const toggle_add_chart = () => {
    set_state((prev) => ({
      ...prev,
      modal_input_chart: !prev.modal_input_chart,
      mode_input_chart: "add",
    }));
  };

  const move_up = (idx) => {
    set_state((prev) => {
      const x_element_custom_order = [...prev.x_element_custom_order];
      const length = x_element_custom_order.length;
      if (length === 0) {
        return prev;
      }
      if (idx !== 0) {
        const value = x_element_custom_order[idx];
        const value_before = x_element_custom_order[idx - 1];
        x_element_custom_order[idx - 1] = value;
        x_element_custom_order[idx] = value_before;
      } else {
        const value = x_element_custom_order[idx];
        const value_before = x_element_custom_order[length - 1];
        x_element_custom_order[length - 1] = value;
        x_element_custom_order[idx] = value_before;
      }
      return {
        ...prev,
        x_element_custom_order,
      };
    });
  };

  const move_down = (idx) => {
    set_state((prev) => {
      const x_element_custom_order = [...prev.x_element_custom_order];
      const length = x_element_custom_order.length;
      if (length === 0) {
        return prev;
      }
      if (idx !== length - 1) {
        const value = x_element_custom_order[idx];
        const value_after = x_element_custom_order[idx + 1];
        x_element_custom_order[idx + 1] = value;
        x_element_custom_order[idx] = value_after;
      } else {
        const value = x_element_custom_order[idx];
        const value_after = x_element_custom_order[0];
        x_element_custom_order[0] = value;
        x_element_custom_order[idx] = value_after;
      }
      return {
        ...prev,
        x_element_custom_order,
      };
    });
  };

  const on_get_x_element_custom_order = (x_axis_field_key_param) => {
    const { layer_id, geo_layer_list } = layer;
    const layer_object_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id
    );
    if (!layer_object_item) {
      return;
    }
    const geo_layer_item = layer_object_item.geo_layer;
    const features = geo_layer_item?.geojson?.features || [];
    const x_element_custom_order = [];
    const key = x_axis_field_key_param;
    features.forEach((feature) => {
      const value = feature?.properties?.[key];
      if (!x_element_custom_order.includes(value)) {
        x_element_custom_order.push(value);
      }
    });
    set_state((prev) => ({
      ...prev,
      x_element_custom_order,
    }));
  };

  const on_submit_add = () => {
    const {
      ina,
      eng,
      x_axis_field_key,
      is_use_y_axis,
      y_axis_field_key,
      chart_type,
      color_default,
      color_hover,
      wacc_field_key,
      is_npv_kai,
      is_use_custom_order,
      x_element_custom_order,
    } = state;
    const { layer_id } = layer;
    const body = {
      geo_layer_id: layer_id,
      chart_object: {
        ina,
        eng,
        x_axis_field_key,
        is_use_y_axis,
        y_axis_field_key,
        chart_type,
        color_default,
        color_hover,
        is_npv_kai,
        is_use_custom_order,
        x_element_custom_order,
        wacc_field_key,
      },
    };
    push_chart_list(body);
    set_state((prev) => ({
      ...prev,
      modal_input_chart: false,
    }));
  };

  const on_submit_edit = () => {
    const {
      _id,
      ina,
      eng,
      x_axis_field_key,
      is_use_y_axis,
      y_axis_field_key,
      chart_type,
      color_default,
      color_hover,
      wacc_field_key,
      is_npv_kai,
      is_use_custom_order,
      x_element_custom_order,
    } = state;
    const { layer_id } = layer;
    const body = {
      geo_layer_id: layer_id,
      chart_object: {
        _id,
        ina,
        eng,
        x_axis_field_key,
        is_use_y_axis,
        y_axis_field_key,
        chart_type,
        color_default,
        color_hover,
        is_npv_kai,
        is_use_custom_order,
        x_element_custom_order,
        wacc_field_key,
      },
    };
    edit_chart_list(body);
    set_state((prev) => ({
      ...prev,
      modal_input_chart: false,
    }));
  };

  const on_change = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    set_state((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const on_toggle = (e) => {
    const { name } = e.target;
    set_state((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const toggle_delete_chart = (chart_id_delete, chart_name_delete) => {
    set_state((prev) => ({
      ...prev,
      modal_delete_chart: !prev.modal_delete_chart,
      chart_id_delete: chart_id_delete || prev.chart_id_delete,
      chart_name_delete: chart_name_delete || prev.chart_name_delete,
    }));
  };

  const on_delete_chart_list = () => {
    const { chart_id_delete } = state;
    const { layer_id } = layer;
    const params = {
      geo_layer_id: layer_id,
      chart_id: chart_id_delete,
    };
    delete_chart_list(params);
    set_state((prev) => ({
      ...prev,
      modal_delete_chart: false,
    }));
  };

  const language = localStorage?.language || auth.language;

  const {
    mode_input_chart,
    modal_input_chart,
    modal_delete_chart,
    // chart_id_delete,
    chart_name_delete,
    ina,
    // eng,
    x_axis_field_key,
    is_use_y_axis,
    y_axis_field_key,
    chart_type,
    // is_npv_kai,
    // wacc_field_key,
    // is_use_custom_order,
    x_element_custom_order,
    // color_default,
    // color_hover,
  } = state;

  const { layer_id, geo_layer_list } = layer;
  // const { domain } = auth;

  // const is_domain_kai = domain_list?.[domain]?.is_domain_kai;
  const layer_object_item = geo_layer_list.find(
    (item) => item.geo_layer._id === layer_id
  );
  const layer_object = layer_object_item ? layer_object_item.geo_layer : {};
  const fields = layer_object?.fields || [];
  const chart_list = layer_object?.chart_list || [];
  // const features = layer_object?.geojson?.features || [];

  const modal_add_chart_content = modal_input_chart && (
    <Modal
      modalSize="large"
      id="modal_input_chart"
      isOpen={modal_input_chart}
      onClose={toggle_add_chart}
    >
      <div className="box-body">
        <main className="max_height">
          <h1 className="text_header">
            {mode_input_chart === "add"
              ? dict?.["Add New Chart"]?.[language]
              : dict?.["Edit Chart"]?.[language]}
          </h1>

          <section className="container background_grey_light">
            <h2 className="text_bold sub_color margin_bottom">
              {dict?.["Title"]?.[language]}
            </h2>
            <input
              className="margin_bottom"
              value={ina}
              name="ina"
              onChange={on_change}
              type="text"
              placeholder={dict?.["Title"]?.[language]}
            />

            <div className="margin_bottom">
              <p className="text_bold sub_color margin_bottom">
                {dict?.["Chart type"]?.[language]}
              </p>
              <select value={chart_type} name="chart_type" onChange={on_change}>
                <option value="line">Line chart (Grafik garis)</option>
                <option value="bar">Bar chart (Grafik batang)</option>
                <option value="pie">Pie chart (Grafik lingkaran)</option>
                <option value="doughnut">Doughnut chart (Grafik donat)</option>
                <option value="polarArea">
                  Polar Area chart (Grafik area polar)
                </option>
              </select>
            </div>

            <div className="margin_bottom">
              <p className="text_bold sub_color margin_bottom">
                {dict?.["Text/label column"]?.[language]}
              </p>
              <Dropdown
                placeholder={dict?.["Select the text column"]?.[language]}
                filter_on
                is_enable_empty={false}
                value={x_axis_field_key}
                onChange={(value) => {
                  set_state((prev) => ({
                    ...prev,
                    x_axis_field_key: value,
                  }));
                  on_get_x_element_custom_order(value);
                }}
              >
                {fields.map((field) => {
                  return (
                    <option key={field.key} value={field.key}>
                      {field.name}
                    </option>
                  );
                })}
              </Dropdown>

              <table className="table margin_top">
                <tbody>
                  {x_element_custom_order.map((item, idx) => {
                    return (
                      <tr key={idx}>
                        <td>
                          <button
                            className="button button_white outline_black"
                            onClick={() => move_up(idx)}
                          >
                            ↑
                          </button>
                        </td>
                        <td>
                          <span className="badge_small background_grey_light">
                            {item}
                          </span>
                        </td>
                        <td>
                          <button
                            className="button button_white outline_black"
                            onClick={() => move_down(idx)}
                          >
                            ↓
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <h2 className="text_bold sub_color margin_bottom">
              {dict?.["Select chart mode"]?.[language]}
            </h2>
            <div className="two_container_equal margin_bottom">
              <div
                className={`container ${
                  !is_use_y_axis
                    ? "background_white outline_black"
                    : "background_grey outline_grey"
                }`}
              >
                <div className="text_center margin_bottom">
                  <button
                    className={`${
                      !is_use_y_axis ? "checklist_active" : "checklist_not"
                    }`}
                    name="is_use_y_axis"
                    onClick={on_toggle}
                  />
                  <p className="text_medium">
                    {dict?.["Single-column text mode"]?.[language]}
                  </p>
                  <p className="text_medium sub_color margin_bottom">
                    {
                      dict?.["Aggregate of the same number of items"]?.[
                        language
                      ]
                    }
                  </p>
                </div>
                <div className="text_center">
                  <img
                    src={chart_image_1}
                    alt="chart_image_1"
                    style={{
                      height: "189px",
                      maxWidth: "100%",
                    }}
                  />
                </div>
              </div>
              <div
                className={`container ${
                  is_use_y_axis
                    ? "background_white outline_black"
                    : "background_grey outline_grey"
                }`}
              >
                <div className="text_center margin_bottom">
                  <button
                    className={`${
                      is_use_y_axis ? "checklist_active" : "checklist_not"
                    }`}
                    name="is_use_y_axis"
                    onClick={on_toggle}
                  />
                  <p className="text_medium">
                    {
                      dict?.[
                        "Single column text and single column numbers mode"
                      ]?.[language]
                    }
                  </p>
                  <p className="text_medium sub_color margin_bottom">
                    {
                      dict?.[
                        "Sum the columns of numbers with the same items"
                      ]?.[language]
                    }
                  </p>
                </div>

                <div className="text_center">
                  <img
                    src={chart_image_2}
                    alt="chart_image_2"
                    style={{
                      height: "189px",
                      maxWidth: "100%",
                    }}
                  />
                </div>

                <div className="margin_bottom">
                  <p className="text_bold sub_color margin_bottom">
                    {dict?.["Number column"]?.[language]}
                  </p>
                  <Dropdown
                    placeholder={dict?.["Select the number column"]?.[language]}
                    filter_on
                    is_enable_empty={false}
                    value={y_axis_field_key}
                    onChange={(value) => {
                      set_state((prev) => ({
                        ...prev,
                        y_axis_field_key: value,
                      }));
                    }}
                  >
                    {fields.map((field) => {
                      return (
                        <option key={field.key} value={field.key}>
                          {field.name}
                        </option>
                      );
                    })}
                  </Dropdown>
                </div>
              </div>
            </div>
          </section>

          <section className="text_center margin_top">
            {mode_input_chart === "add" ? (
              <button
                className="button_big background_black"
                onClick={on_submit_add}
              >
                {dict?.["Save"]?.[language]}
              </button>
            ) : (
              <button
                className="button_big background_black"
                onClick={on_submit_edit}
              >
                {dict?.["Save changes"]?.[language]}
              </button>
            )}
          </section>
        </main>
      </div>
    </Modal>
  );

  const modal_delete_chart_content = modal_delete_chart && (
    <Modal
      modalSize="small"
      id="toggle_delete_chart"
      isOpen={modal_delete_chart}
      onClose={toggle_delete_chart}
    >
      <div className="box-body">
        <h1 className="text_header">
          {dict?.["Confirm delete chart"]?.[language]}
        </h1>
        <table className="table">
          <tbody>
            <tr>
              <td>{dict?.["Name"]?.[language]}</td>
              <td>{chart_name_delete}</td>
            </tr>
          </tbody>
        </table>
        <p className="text_medium">
          {dict?.["Deleted charts cannot be restored."]?.[language]}
        </p>
        <br />
        <br />
        <button
          className="button background_red"
          onClick={on_delete_chart_list}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </Modal>
  );

  return (
    <main className="max_height">
      {modal_delete_chart_content}
      {modal_add_chart_content}
      <h1 className="text_header">{dict?.["Chart"]?.[language]}</h1>
      <section>
        {chart_list.length === 0 ? (
          <div className="container background_grey_light">
            {dict?.["No graph has been created for this layer yet"]?.[language]}
          </div>
        ) : (
          <div>
            {chart_list.map((item, idx) => {
              const { chart_type, chart_js_data } = item;

              // Safety check for chart_js_data
              if (
                !chart_js_data ||
                !chart_js_data.datasets ||
                !chart_js_data.datasets[0]
              ) {
                return null;
              }

              let chartData = { ...chart_js_data };
              const label_array = chartData.datasets[0].labels || [];
              const value_array = chartData.datasets[0].data || [];
              const color_array = generate_array_color(label_array);
              chartData.datasets[0].backgroundColor = color_array;
              chartData.datasets[0].borderColor = color_array;
              chartData.datasets[0].borderWidth = 1;

              const is_circle_chart = ["pie", "doughnut", "polarArea"].includes(
                chart_type
              );
              const isLongChart = ["bar", "line", "area"].includes(chart_type);
              const chartHeight = isLongChart ? 150 : undefined;

              // Calculate total and percentages for legend
              const numericData = value_array.map((d) =>
                typeof d === "object" && d !== null ? d.y : d
              );
              const total = numericData.reduce((sum, val) => sum + val, 0);

              const chartOptions = {
                responsive: true,
                maintainAspectRatio: !isLongChart,
                plugins: {
                  legend: { display: false },
                  tooltip: { enabled: true },
                },
                scales: isLongChart
                  ? {
                      x: {
                        beginAtZero: true,
                        ticks: { display: chart_type === "line" },
                      },
                      y: {
                        beginAtZero: true,
                      },
                    }
                  : {},
              };

              const custom_legend = (
                <section
                  className="container background_white"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    borderRadius: "5px",
                  }}
                >
                  <table>
                    <tbody>
                      {label_array.map((label, index) => {
                        const count = numericData[index];
                        const percentage =
                          total > 0
                            ? ((count / total) * 100).toFixed(1)
                            : "0.0";
                        return (
                          <tr
                            key={index}
                            style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                          >
                            <td
                              style={{
                                verticalAlign: "top",
                                paddingRight: "8px",
                                textAlign: "center",
                                width: "30px",
                              }}
                            >
                              <div
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor:
                                    color_array[index] || "transparent",
                                  margin: "0 auto",
                                }}
                              />
                            </td>
                            <td>
                              <div>
                                <p className="text_medium">{label} </p>
                                <span className="text_small">{count}</span>{" "}
                                <span className="text_small sub_color">
                                  ({percentage} %)
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </section>
              );

              let final_content;

              if (is_circle_chart) {
                final_content = (
                  <main
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <section style={{ width: "77px" }}>
                      <Chart
                        type={chart_type}
                        data={chartData}
                        options={chartOptions}
                        style={{ height: chartHeight, maxHeight: chartHeight }}
                      />
                    </section>
                    <section style={{ width: "100%" }}>{custom_legend}</section>
                  </main>
                );
              } else {
                final_content = (
                  <main style={{ width: "100%" }}>
                    <div
                      style={{
                        overflowX: "auto",
                        paddingBottom: "1rem",
                      }}
                    >
                      <div
                        style={{ minWidth: `${label_array.length * 30}px` }}
                        className="container background_white"
                      >
                        <Chart
                          type={chart_type}
                          data={chartData}
                          options={chartOptions}
                          style={{
                            height: chartHeight,
                            maxHeight: chartHeight,
                          }}
                        />
                      </div>
                    </div>
                    {custom_legend}
                  </main>
                );
              }

              return (
                <section
                  key={idx}
                  className="container background_grey_light outline_grey margin_bottom margin_right"
                  style={{
                    width: "279px",
                    display: "inline-block",
                    verticalAlign: "top",
                  }}
                >
                  <h2 className="text_medium sub_color margin_bottom">
                    {item.ina}
                  </h2>
                  <section>
                    <button
                      className="button_small background_black margin_right margin_bottom"
                      onClick={() => toggle_edit_chart(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="button_small background_red margin_right margin_bottom"
                      onClick={() => toggle_delete_chart(item._id, item.ina)}
                    >
                      {dict?.["Delete"]?.[language]}
                    </button>
                  </section>
                  {final_content}
                </section>
              );
            })}
          </div>
        )}
      </section>
      <section className="text_center margin_top">
        <button
          className="button_big background_black"
          onClick={toggle_add_chart}
        >
          {dict?.["Add a chart"]?.[language]}
        </button>
      </section>
    </main>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
  getDetailLayerById,
})(MANAGE_CHART);
